import React, { useState, useEffect } from 'react';
import './App.css';
import chucklesImage from './chuckles.png';
import stockChartImage from './stock price chart.png';

function App() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    // Update date every minute
    const timer = setInterval(() => {
      setCurrentDate(new Date());
    }, 60000); // 60000 ms = 1 minute

    // Cleanup interval on component unmount
    return () => clearInterval(timer);
  }, []); // Empty dependency array means this effect runs once on mount

  const handleChartClick = () => {
    setIsPopupOpen(true);
    // Prevent body scrolling when popup is open
    document.body.style.overflow = 'hidden';
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    // Restore body scrolling
    document.body.style.overflow = 'auto';
  };

  // Close popup when clicking outside or pressing escape
  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === 'Escape') {
        handleClosePopup();
      }
    };

    if (isPopupOpen) {
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isPopupOpen]);

  return (
    <div className="wsj-container">
      <header className="wsj-header">
        <div className="wsj-top-bar">
          <span>MARKETS</span>
          <span className="wsj-date">
            {currentDate.toLocaleDateString('en-US', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </span>
        </div>
        <h1 className="wsj-title">CHUCKLES CAPITAL</h1>
      </header>
      
      <main className="wsj-content">
        <article className="wsj-article">
          <h2 className="section-title">Strategy Backed By Princeton Research</h2>
          
          <div className="article-quote">
            <blockquote>
              "A blindfolded monkey throwing darts at a newspaper's financial pages could select a portfolio that would do just as well as one carefully selected by experts."
            </blockquote>
            <cite>– Burton Malkiel, Economics Professor And Two-Time Department Chairman, Princeton University</cite>
          </div>

          <div className="performance-section">
            <div className="chart-layout">
              <div className="chart-description">
                <p>Illustrative historical returns of a hypothetical portfolio based on Burton Malkiel's research. Barclay Hedge Fund Index based on data from 2709 funds.</p>
              </div>
              <div className="chart-container" onClick={handleChartClick}>
                <img 
                  src={stockChartImage} 
                  alt="Five-Year Returns of Illustrative Portfolios showing Chuckles at +106%, S&P 500 at +65%, and Hedge Funds at +27%" 
                  className="stock-chart"
                />
              </div>
            </div>
            <div className="performance-highlight">
              <ul>
                <li><strong>Chuckles¹:</strong> +106%</li>
                <li><strong>S&P 500²:</strong> +65%</li>
                <li><strong>Hedge Funds³:</strong> +27%</li>
              </ul>
            </div>
          </div>

          <section>
            <h2 className="section-title">Portfolio Highlights</h2>
            <div className="fund-highlights">
              <div className="chuckles-portrait-container">
                <img src={chucklesImage} alt="Mr. Chuckles" className="chuckles-portrait" />
              </div>
              <div className="key-features">
                <ul>
                  <li>
                    <span className="bullet">❖</span>
                    <span className="feature-text">Guidance of Mr. Chuckles, a blindfolded monkey</span>
                  </li>
                  <li>
                    <span className="bullet">❖</span>
                    <span className="feature-text">Contrarian strategy</span>
                  </li>
                  <li>
                    <span className="bullet">❖</span>
                    <span className="feature-text">Transparent stock selection process, broadcast to the public in a yearly publicized event with Mr. Chuckles</span>
                  </li>
                  <li>
                    <span className="bullet">❖</span>
                    <span className="feature-text">Annual reports signed by Mr. Chuckles</span>
                  </li>
                  <li>
                    <span className="bullet">❖</span>
                    <span className="feature-text">Exclusive Chuckles Club membership with benefits</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 className="section-title">Strategic Partnerships</h2>
            <p className="funding-notice">
              Chuckles Capital is currently in discussions with strategic partners to hire and retain a trained monkey, which will design a portfolio of stocks by throwing darts. Inquire at <a href="mailto:inquire@chuckles.us">inquire@chuckles.us</a>
            </p>
          </section>

          <footer className="disclaimer">
            <p><small>¹ Hypothetical returns of a portfolio consisting of 30 stocks selected from Russell 1000 Index at random on 15-Nov-2018 and held for 5 years; ² S&P 500 Index; ³ Barclay Hedge Fund Index based on data from 2709 funds.</small></p>
            <p><small><em>This website serves as a preliminary overview and does not constitute an offer or solicitation to back Mr. Chuckles or affiliated entities. Potential backers are encouraged to carefully review all official offering documents prior to making any decisions. Past performance is not indicative of future results.</em></small></p>
          </footer>
        </article>
      </main>

      {/* Popup */}
      <div className={`popup-overlay ${isPopupOpen ? 'active' : ''}`} onClick={handleClosePopup}>
        <div className="popup-content" onClick={e => e.stopPropagation()}>
          <img 
            src={stockChartImage} 
            alt="Five-Year Returns of Illustrative Portfolios showing Chuckles at +106%, S&P 500 at +65%, and Hedge Funds at +27%" 
            className="popup-image"
          />
        </div>
      </div>
    </div>
  );
}

export default App;
